export const products = {
  title: 'Gestion des Produits',
  searchPlaceholder: 'Rechercher des produits...',
  columns: {
    barcode: 'Référence',
    category: 'Catégorie',
    name: 'Désignation',
    description: 'Description',
    price: 'Prix en Dh',
    cost: 'Coût',
    stock: 'Stock',
    isService: 'Type',
    image: 'Image',
    isActive: 'Statut',
    tauxTva: 'TVA',
    unite: 'Unité',
    createdAt: 'Date de création',
    updatedAt: 'Dernière modification',
    lastSync: 'Dernière synchronisation',
    packItems: 'Articles du pack',
    modeleVenteId: 'Modèle de vente',
    // Sections pour les colonnes collapsibles
    basicInfo: 'Informations de base',
    financialInfo: 'Détails financiers',
    systemInfo: 'Informations système'
  },
  filters: {
    search: {
      label: 'Recherche',
      placeholder: 'Rechercher par nom, référence...'
    },
    sort: {
      label: 'Trier par',
      placeholder: 'Sélectionner un champ',
      directions: {
        asc: 'Croissant',
        desc: 'Décroissant'
      }
    },
    category: {
      label: 'Catégorie',
      allCategories: 'Toutes les catégories'
    },
    type: {
      label: 'Type',
      all: 'Tous les types',
      product: 'Produit',
      service: 'Service',
      pack: 'Pack',
      matiere_premiere: 'Matière première',
      piece_detachee: 'Pièce détachée'
    },
    priceRange: {
      label: 'Fourchette de prix',
      allPrices: 'Tous les prix',
      ranges: {
        '0-100': '0 - 100 Dh',
        '100-500': '100 - 500 Dh',
        '500+': '500+ Dh'
      }
    },
    stockStatus: {
      label: 'État du stock',
      all: 'Tous',
      inStock: 'En stock',
      lowStock: 'Stock faible',
      outOfStock: 'Rupture de stock'
    },
    dateRange: {
      label: 'Période',
      startDate: 'Date de début',
      endDate: 'Date de fin'
    }
  },
  actions: {
    newProduct: 'Nouveau Produit',
    delete: 'Supprimer'
  },
  pagination: {
    totalItems: 'Total des éléments',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page'
  },
  form: {
    createTitle: 'Nouveau Produit',
    editTitle: 'Modifier le Produit',
    tabs: {
      main: 'Informations principales',
      secondary: 'Informations secondaires'
    },
    imageHelp: 'Cliquez pour ajouter une image',
    fields: {
      barcode: 'Référence',
      name: 'Désignation',
      category: 'Catégorie',
      price: 'Prix',
      cost: 'Coût',
      tauxTva: 'TVA',
      stock: 'Stock',
      isService: 'Type de produit',
      image: 'Image'
    },
    placeholders: {
      barcode: 'Entrez la référence',
      name: 'Entrez la désignation',
      category: 'Sélectionnez une catégorie',
      price: 'Entrez le prix',
      stock: 'Entrez le stock',
      image: 'Sélectionnez une image'
    },
    buttons: {
      save: 'Enregistrer',
      cancel: 'Annuler'
    },
    validations: {
      required: 'Ce champ est requis',
      number: 'Veuillez entrer un nombre valide',
      positive: 'Le nombre doit être positif'
    },
    create: 'Créer',
    update: 'Mettre à jour',
    cancel: 'Annuler',
    submitting: 'Enregistrement...'
  },
  confirmations: {
    delete: 'Êtes-vous sûr de vouloir supprimer ce produit ?'
  },
  common: {
    notDefined: 'Non défini'
  },
  units: {
    piece: 'Pièce',
    kg: 'Kilogramme',
    g: 'Gramme',
    l: 'Litre',
    ml: 'Millilitre',
    m: 'Mètre',
    cm: 'Centimètre',
    m2: 'Mètre carré',
    m3: 'Mètre cube',
    h: 'Heure',
    forfait: 'Forfait'
  }
}; 